import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../../services/translate/translate.module';
import { CoreModule } from '../../../core/core.module';
import { CustomTabsModule } from '../../../shared-components/custom-tabs/custom-tabs.module';
import { CustomTableModule } from '../../../shared-components/custom-table/custom-table.module';
import { CustomBreadcrumbsModule } from '../../../shared-components/custom-breadcrumbs/custom-breadcrumbs.module';
import { FinancialMovementsComponent } from './financial-movements.component';
import { FinancialMovementsRegistrationTabComponent } from './tabs/financial-movements-registration-tab/financial-movements-registration-tab.component';
import { FinancialMovementsDetailsTabComponent } from './tabs/financial-movements-details-tab/financial-movements-details-tab.component';

@NgModule({
	declarations: [FinancialMovementsComponent, FinancialMovementsRegistrationTabComponent, FinancialMovementsDetailsTabComponent],
	imports: [CommonModule, TranslateModule, CoreModule, CustomTabsModule, CustomTableModule, CustomBreadcrumbsModule],
	exports: [FinancialMovementsComponent],
})
export class FinancialMovementsModule {}
